// extracted by mini-css-extract-plugin
module.exports = {"Summary":"Topic_Summary_Summary__RlP_N","Image":"Topic_Summary_Image__cLNUS","Text":"Topic_Summary_Text__8NuFs","Links":"Topic_Summary_Links__mOcjk"};